export function pickColor() {
    const colorBtns = document.querySelectorAll('[data-halats-color]');
    const nextUrl = document.querySelector('meta[name="next-page"]')?.content;
    if (colorBtns && nextUrl) {
        for (let colorBtn of colorBtns) {
            colorBtn.addEventListener('mousedown', () => {
                console.log(colorBtn.dataset.halatsColor);
                sessionStorage.setItem('color', colorBtn.dataset.halatsColor);
                setTimeout(() => {
                    const url = new URL(window.location.href + nextUrl);
                    url.searchParams.set('krasa', colorBtn.dataset.halatsColor);
                    window.location.href = url;
                }, 200)
            })
        }
    }
}